// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#layoutTopbar {
  background-color: var(--bdpMenuBackgroundTop);
}
#layoutTopbar .progressBar {
  display: flex;
  justify-content: center;
  margin-top: 60px;
}
#layoutTopbar .layout-topbar-wrapper {
  flex-flow: row;
}
#layoutTopbar .layout-topbar-wrapper .layout-topbar-left ul {
  list-style-type: none;
  max-width: 400px;
  padding-left: 20px;
  margin: 0px;
  height: 100%;
}
#layoutTopbar .layout-topbar-wrapper .layout-topbar-left ul li {
  display: inline;
}
#layoutTopbar .layout-topbar-wrapper .layout-topbar-left ul li img.bdp-logo {
  width: 100px;
  max-width: 100%;
  margin-top: 5px;
  margin-bottom: 5px;
}
#layoutTopbar .layout-topbar-wrapper .layout-topbar-left ul li img.smart-suite-logo {
  min-width: 413px;
  max-width: 100%;
  height: 55px;
  scale: 1.1;
  margin-left: 20px;
}
::ng-deep .bdp-notification-badge {
  right: 10px;
  top: -4px;
  background: #d71717;
  font-size: 12px;
  font-weight: normal;
  color: #fff;
}
::ng-deep #badgeButton .p-button {
  padding: 4px;
  background-color: #2f80ed;
  line-height: 1px;
}
::ng-deep #badgeButton .p-button .p-badge {
  margin: 0px 10px;
}
::ng-deep #alertContent .p-overlaypanel {
  position: absolute;
  left: 60px !important;
  right: 10px !important;
  top: 12px !important;
}
::ng-deep #alertContent .p-overlaypanel p {
  padding: 5px 10px;
  border-radius: 6px;
}
::ng-deep #alertContent .p-overlaypanel p:hover {
  background-color: #2f80ed;
  color: #fff;
}
::ng-deep #alertContent .p-overlaypanel:after,
::ng-deep #alertContent .p-overlaypanel:before {
  content: normal;
}
::ng-deep #alertContent .readBackground {
  background: #edfaff;
}
::ng-deep #alertContent .bdp-alert-wrapper .bdp-alert-heading {
  float: left;
  width: calc(100% - 25px);
  font-size: 16px;
  margin-bottom: 0px;
}
::ng-deep #alertContent .bdp-alert-wrapper .truncate {
  width: 225px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  color: var(--bdpFontPrimary);
}
::ng-deep #alertContent .bdp-alert-wrapper .notif-text-width {
  display: inline-block;
  font-size: 12px;
  color: #6c7082;
  width: 240px;
}
::ng-deep #alertContent .bdp-alert-wrapper .bdp-menu-icon {
  width: 24px;
  text-align: center;
  float: left;
  height: 24px;
  border-radius: 3px;
  padding: 5px;
}
::ng-deep #alertContent .bdp-alert-wrapper .bdp-menu-icon:hover {
  background-color: #2d74ff;
  color: #fff;
}
::ng-deep #alertContent .bdp-alert-wrapper .p-jc-between {
  position: relative;
}
::ng-deep #alertContent .bdp-alert-wrapper .p-jc-between .p-slidemenu-overlay {
  position: absolute;
  left: 55px !important;
  top: 23px !important;
}

.bdp-notification-badge {
  height: 15px !important;
  width: 25px !important;
  min-width: 14px;
  font-size: 10px;
  line-height: 15px !important;
}

@media only screen and (max-width: 600px) {
  #layoutTopbar .layout-topbar-wrapper .layout-topbar-left ul li img.smart-suite-logo {
    width: 600px;
    max-width: 100%;
    margin-left: 0;
  }
  .bdp-alert-body {
    max-height: 220px;
    min-height: 220px;
    overflow-y: scroll;
  }
  .bdp-alert-body .readBackground {
    background: #edfaff;
  }
  .notif-menu-font-size {
    font-size: 12px;
  }
  .notif-menu {
    cursor: pointer;
  }
  ::ng-deep .p-overlaypanel {
    width: 340px !important;
  }
  ::ng-deep .p-tabview .p-tabview-nav li .p-tabview-nav-link {
    padding: 0.8rem 0.6rem !important;
  }
  ::ng-deep .p-overlaypanel .p-overlaypanel-content {
    max-height: 350px !important;
  }
  ::ng-deep .p-tabview .p-tabview-panels {
    padding-bottom: 0;
  }
  ::ng-deep .p-overlaypanel:after,
  ::ng-deep .p-overlaypanel:before {
    content: unset !important;
  }
}
@media (max-width: 430px) {
  .layout-topbar-actions > .topbar-item > ul {
    left: auto;
  }
}
@media (max-width: 992px) {
  #layoutTopbar .layout-topbar-actions {
    padding: 0px;
  }
  .bdp-dropdown-icon,
  .smart-suite-logo {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/direct-link/direct-link-topbar/direct-link-topbar.component.scss"],"names":[],"mappings":"AAAA;EACI,6CAAA;AACJ;AAAI;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;AAER;AAAI;EACI,cAAA;AAER;AACY;EACI,qBAAA;EAEA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAAhB;AAEgB;EACI,eAAA;AAApB;AACoB;EACI,YAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AACxB;AAIoB;EACI,gBAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;AAFxB;AA0BI;EACI,WAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AAxBR;AA4BQ;EACI,YAAA;EACA,yBAAA;EACA,gBAAA;AA1BZ;AA4BY;EACI,gBAAA;AA1BhB;AAgCQ;EACI,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,oBAAA;AA9BZ;AAgCY;EACI,iBAAA;EACA,kBAAA;AA9BhB;AAgCgB;EACI,yBAAA;EACA,WAAA;AA9BpB;AAmCQ;;EAEI,eAAA;AAjCZ;AAoCQ;EACI,mBAAA;AAlCZ;AAsCY;EACI,WAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;AApChB;AAuCY;EACI,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,4BAAA;AArChB;AAwCY;EAEI,qBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AAvChB;AA0CY;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AAxChB;AA0CgB;EACI,yBAAA;EACA,WAAA;AAxCpB;AA4CY;EACI,kBAAA;AA1ChB;AA4CgB;EACI,kBAAA;EACA,qBAAA;EACA,oBAAA;AA1CpB;;AAiDA;EACI,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;EACA,4BAAA;AA9CJ;;AAiDA;EACI;IACI,YAAA;IACA,eAAA;IACA,cAAA;EA9CN;EAiDE;IACI,iBAAA;IACA,iBAAA;IACA,kBAAA;EA/CN;EAiDM;IACI,mBAAA;EA/CV;EAmDE;IACI,eAAA;EAjDN;EAoDE;IACI,eAAA;EAlDN;EAsDM;IACI,uBAAA;EApDV;EAuDM;IACI,iCAAA;EArDV;EAwDM;IACI,4BAAA;EAtDV;EAyDM;IACI,iBAAA;EAvDV;EA0DM;;IAEI,yBAAA;EAxDV;AACF;AA4DA;EACI;IACI,UAAA;EA1DN;AACF;AA6DA;EACI;IACI,YAAA;EA3DN;EA8DE;;IAEI,aAAA;EA5DN;AACF","sourcesContent":["#layoutTopbar {\n    background-color: var(--bdpMenuBackgroundTop);\n    .progressBar {\n        display: flex;\n        justify-content: center;\n        margin-top: 60px;\n    }\n    .layout-topbar-wrapper {\n        flex-flow: row;\n\n        .layout-topbar-left {\n            ul {\n                list-style-type: none;\n                //float: left;\n                max-width: 400px;\n                padding-left: 20px;\n                margin: 0px;\n                height: 100%;\n\n                li {\n                    display: inline;\n                    img.bdp-logo {\n                        width: 100px;\n                        max-width: 100%;\n                        margin-top: 5px;\n                        margin-bottom: 5px;\n                    }\n\n                    \n\n                    img.smart-suite-logo {\n                        min-width: 413px;\n                        max-width: 100%;\n                        height: 55px;\n                        scale: 1.1;\n                        margin-left: 20px;\n                    }\n                }\n            }\n        }\n\n        \n\n        #notificationList {}\n    }\n\n    \n}\n\n// :host ::ng-deep .custom-spinner {\n//     .custom-progress-spinner-color {\n//         stroke: #16697a;\n//     }\n//     .p-progress-spinner-circle {\n//         animation: custom-progress-spinner-dash 1.5s ease-in-out infinite;\n//     }\n// }\n\n::ng-deep {\n    .bdp-notification-badge {\n        right: 10px;\n        top: -4px;\n        background: #d71717;\n        font-size: 12px;\n        font-weight: normal;\n        color: #fff;\n    }\n\n    #badgeButton {\n        .p-button {\n            padding: 4px;\n            background-color: #2f80ed;\n            line-height: 1px;\n\n            .p-badge {\n                margin: 0px 10px;\n            }\n        }\n    }\n\n    #alertContent {\n        .p-overlaypanel {\n            position: absolute;\n            left: 60px !important;\n            right: 10px !important;\n            top: 12px !important;\n\n            p {\n                padding: 5px 10px;\n                border-radius: 6px;\n\n                &:hover {\n                    background-color: #2f80ed;\n                    color: #fff;\n                }\n            }\n        }\n\n        .p-overlaypanel:after,\n        .p-overlaypanel:before {\n            content: normal;\n        }\n\n        .readBackground {\n            background: #edfaff;\n        }\n\n        .bdp-alert-wrapper {\n            .bdp-alert-heading {\n                float: left;\n                width: calc(100% - 25px);\n                font-size: 16px;\n                margin-bottom: 0px;\n            }\n\n            .truncate {\n                width: 225px;\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                font-size: 14px;\n                color: var(--bdpFontPrimary);\n            }\n\n            .notif-text-width {\n                // width: 150px;\n                display: inline-block;\n                font-size: 12px;\n                color: #6c7082;\n                width: 240px;\n            }\n\n            .bdp-menu-icon {\n                width: 24px;\n                text-align: center;\n                float: left;\n                height: 24px;\n                border-radius: 3px;\n                padding: 5px;\n\n                &:hover {\n                    background-color: #2d74ff;\n                    color: #fff;\n                }\n            }\n\n            .p-jc-between {\n                position: relative;\n\n                .p-slidemenu-overlay {\n                    position: absolute;\n                    left: 55px !important;\n                    top: 23px !important;\n                }\n            }\n        }\n    }\n}\n\n.bdp-notification-badge {\n    height: 15px !important;\n    width: 25px !important;\n    min-width: 14px;\n    font-size: 10px;\n    line-height: 15px !important;\n}\n\n@media only screen and (max-width: 600px) {\n    #layoutTopbar .layout-topbar-wrapper .layout-topbar-left ul li img.smart-suite-logo {\n        width: 600px;\n        max-width: 100%;\n        margin-left: 0;\n    }\n\n    .bdp-alert-body {\n        max-height: 220px;\n        min-height: 220px;\n        overflow-y: scroll;\n\n        .readBackground {\n            background: #edfaff;\n        }\n    }\n\n    .notif-menu-font-size {\n        font-size: 12px;\n    }\n\n    .notif-menu {\n        cursor: pointer;\n    }\n\n    ::ng-deep {\n        .p-overlaypanel {\n            width: 340px !important;\n        }\n\n        .p-tabview .p-tabview-nav li .p-tabview-nav-link {\n            padding: 0.8rem 0.6rem !important;\n        }\n\n        .p-overlaypanel .p-overlaypanel-content {\n            max-height: 350px !important;\n        }\n\n        .p-tabview .p-tabview-panels {\n            padding-bottom: 0;\n        }\n\n        .p-overlaypanel:after,\n        .p-overlaypanel:before {\n            content: unset !important;\n        }\n    }\n}\n\n@media (max-width: 430px) {\n    .layout-topbar-actions>.topbar-item>ul {\n        left: auto;\n    }\n}\n\n@media (max-width: 992px) {\n    #layoutTopbar .layout-topbar-actions {\n        padding: 0px;\n    }\n\n    .bdp-dropdown-icon,\n    .smart-suite-logo {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
